<template>
  <SocialMarketingCardContainer :inProgress="inProgress">
    <SocialMarketingImage
      :userImage="marketingAsset.image"
      :gradient="backgroundGradient"
      :editMode="editMode"
    >
      <div class="card-p-3 flex-1 justify-content-between d-flex flex-column">
        <SocialMarketingStudioInfo
          class="card-mb-3"
          color="light"
          :studioUrl="studioUrl"
        />
        <SocialMarketingStudioContent
          :title="marketingAsset.title"
          :description="marketingAsset.description"
          :descriptionMaxLines="6"
          colorType="light"
        />
      </div>
    </SocialMarketingImage>
  </SocialMarketingCardContainer>
</template>

<script>
import SocialMarketingCardContainer from '@/web/components/marketing/SocialMarketingCardContainer.vue';
import SocialMarketingStudioInfo from '@/web/components/marketing/SocialMarketingStudioInfo.vue';
import SocialMarketingStudioContent from '@/web/components/marketing/SocialMarketingStudioContent.vue';
import SocialMarketingImage from '@/web/components/marketing/SocialMarketingImage.vue';

export default {
  name: 'Template2',
  components: {
    SocialMarketingCardContainer,
    SocialMarketingStudioInfo,
    SocialMarketingStudioContent,
    SocialMarketingImage,
  },
  computed: {
    marketingAsset() {
      return this.value;
    },
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    inProgress: {
      type: Boolean,
      default: false,
    },
    isDownload: {
      type: Boolean,
      default: false,
    },
    studioUrl: {
      type: String,
      default: '',
    },
    backgroundGradient: {
      type: String,
      default:
        'linear-gradient(360deg, rgba(16, 22, 24, 0.80) 0%, rgba(16, 22, 24, 0.00) 100%)',
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
